import React from "react";
import PageTemplate from "../../../templates/page-template";

export default function BecomeAMentorPage() {
	return (
    <PageTemplate header="Become A Mentor"/>
	);
}
